package songwritersnotebook.app.screens

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun TermsOfServiceScreen(onBack: () -> Unit) {
    Scaffold(
        topBar = {
            TopAppBar(
                title = { Text("Terms of Service", fontWeight = FontWeight.Bold) },
                navigationIcon = {
                    IconButton(onClick = onBack) {
                        Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Back")
                    }
                }
            )
        }
    ) { padding ->
        Column(
            modifier = Modifier
                .padding(padding)
                .padding(16.dp)
                .fillMaxSize()
                .verticalScroll(rememberScrollState())
        ) {
            Text("Last Updated: May 25, 2026", style = MaterialTheme.typography.labelMedium)
            Spacer(modifier = Modifier.height(24.dp))
            
            Text("1. Acceptance of Terms", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text("By accessing or using Songwriter's Notebook, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the Service.", style = MaterialTheme.typography.bodyMedium)
            
            Spacer(modifier = Modifier.height(16.dp))
            Text("2. User Content & Ownership", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text("You retain 100% of the ownership rights to all original lyrics, chords, melodies, and recordings you create or store within the app. Breakwater Labs LLC claims no ownership over your intellectual property. By using the app, you grant us a limited, necessary license solely to securely store, display, and synchronize your data across your devices.", style = MaterialTheme.typography.bodyMedium)
            
            Spacer(modifier = Modifier.height(16.dp))
            Text("3. AI Features & Fair Use Policy", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text(
                "To ensure high performance and availability for all users, the \"Unlimited AI Generation\" feature available on the Studio Tier is subject to a Fair Use Policy. " +
                "Your account is granted 100 AI generation requests per day. This limit resets at midnight every day. " +
                "We reserve the right to throttle or temporarily suspend AI generation capabilities for any account demonstrating automated, non-human, or abusive usage patterns. " +
                "This limit is designed to be well above the normal usage requirements of a songwriter and is strictly enforced to protect the integrity of the Service.",
                style = MaterialTheme.typography.bodyMedium
            )

            Spacer(modifier = Modifier.height(16.dp))
            Text("4. Subscriptions and Payments", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text("Premium features are billed on a subscription or one-time purchase basis. Subscriptions are billed in advance on a recurring schedule. You may cancel your subscription at any time through your respective app store or billing portal. No refunds will be issued for partially used billing periods.", style = MaterialTheme.typography.bodyMedium)
            
            Spacer(modifier = Modifier.height(16.dp))
            Text("5. Limitation of Liability", style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
            Spacer(modifier = Modifier.height(8.dp))
            Text("In no event shall Breakwater Labs LLC be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of, or inability to access or use the Service.", style = MaterialTheme.typography.bodyMedium)
            
            Spacer(modifier = Modifier.height(32.dp))
        }
    }
}
